import React from 'react'
import { withRouter } from 'react-router-dom'
import formatLangUrl from '../../../../helpers/formatLangUrl'
import { useSelector } from 'react-redux'
import { lang } from 'moment'

const BookameetingFooter = withRouter(({ history }) => {
  const {
    ncc,
    nch,
    becomeAMember,
    signUpHere,
    signUpHereLink,
    language,
    english,
    svenska,
    aboutUs,
    aboutUsLink,
    mapOver,
    mapOverLink,
    prideRoomForAll,
    prideRoomForAllLink,
    nchApp,
    nchAppLink,
    sustainability,
    sustainabilityLink,
    whistleBlowing,
    whistleBlowingLink,
    workAtNch,
    workAtNchLink,
    becomeAffiliate,
    becomeAffiliateLink,
    ourHotels,
    comfortHotel,
    comfortHotelLink,
    qualityHotel,
    qualityHotelLink,
    clarionHotel,
    clarionHotelLink,
    independentHotels,
    independentHotelsLink,
    airportHotels,
    airportHotelsLink,
    spaHotels,
    spaHotelsLink,
    hotelsWithPools,
    ourDestinations,
    ourDestinationsLink,
    hotelsWithPoolsLink,
    customerService,
    customerServiceLink,
    contactUs,
    contactUsLink,
    faq,
    faqLink,
    findYourBooking,
    findYourBookingLink,
    bestPriceGuarantee,
    bestPriceGuaranteeLink,
    userTermsForSiteAndApp,
    userTermsForSiteAndAppLink,
    termsAndConditionsPrivacy,
    termsAndConditionsPrivacyLink,
    followUs,
    suomi,
    norsk,
    dansk
  } = useSelector((state) => state.language.text)

  const supportLanguages = [
    { label: svenska, value: 'sv' },
    { label: english, value: 'en' },
    { label: suomi, value: 'fi' },
    { label: norsk, value: 'no' },
    { label: dansk, value: 'da' }
  ]

  const langcode = useSelector((state) => state.language.langcode)
  const fullLangName = supportLanguages.find(({ value }) => value === langcode)
    ? supportLanguages.find(({ value }) => value === langcode).label
    : ''

  return (
    <div>
      <footer id="mainFooterReact" role="contentinfo">
        <div className="page__container footer__wrapper  explorer-page ">
          <section className="footer-grid">
            <div className="footer-grid__item footer-grid__item-4">
              <div>
                <div>
                  <div className="sign-box">
                    <div className="sign-box__content">
                      <div className="h4 sign-box__title">
                        <div>{ncc}</div>
                      </div>
                      <p></p>
                      <div className="sign-box__p">{becomeAMember}</div>
                      <a
                        href={signUpHereLink}
                        id="signupButton"
                        className="btn btn-secondary btn--uppercase"
                        rel="noopener noreferrer">
                        <div>{signUpHere}</div>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="footer__box">
                    <div>
                      <div className="h4 footer__title">{language}</div>
                      <div className="language-selector">
                        <div
                          id="nch-language-selector"
                          className="language-selector__label footer-header-link"
                          title="Language">
                          {fullLangName}
                          <select
                            id="nch-language-dropdown"
                            onChange={(e) => {
                              const searchQuery =
                                e.target.value === 'en'
                                  ? history.location.search.includes('?lang=en')
                                    ? history.location.search
                                    : history.location.search + '?lang=en'
                                  : history.location.search.replace(
                                      '?lang=en',
                                      ''
                                    )
                              history.push(
                                formatLangUrl(
                                  `${history.location.pathname}${searchQuery}`,
                                  e.target.value
                                )
                              )
                            }}
                            value={langcode}>
                            {supportLanguages.map(({ value, label }) => (
                              <option key={value} value={value}>
                                {label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-grid__item footer-grid__item-4">
              <div>
                <div>
                  <div className="footer__box">
                    <div className="h4 footer__title">
                      <div>{ncc}</div>
                    </div>
                    <ul className="footer-links">
                      <li>
                        <a
                          href={aboutUsLink}
                          title={aboutUs}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {aboutUs}
                          </span>
                        </a>
                      </li>
                      {langcode === 'en' && (
                        <li>
                          <a
                            href={mapOverLink}
                            title={mapOver}
                            className="footer-header-link"
                            rel="noopener noreferrer">
                            <span className="footer-header-link__inside">
                              {mapOver}
                            </span>
                          </a>
                        </li>
                      )}
                      {langcode === 'sv' && (
                        <li>
                          <a
                            href={workAtNchLink}
                            title={workAtNch}
                            className="footer-header-link"
                            rel="noopener noreferrer">
                            <span className="footer-header-link__inside">
                              {workAtNch}
                            </span>
                          </a>
                        </li>
                      )}
                      <li>
                        <a
                          href={prideRoomForAllLink}
                          title={prideRoomForAll}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {prideRoomForAll}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={nchAppLink}
                          title={nchApp}
                          className="footer-header-link   "
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {nchApp}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={sustainabilityLink}
                          title={sustainability}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {sustainability}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={whistleBlowingLink}
                          title={whistleBlowing}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {whistleBlowing}
                          </span>
                        </a>
                      </li>
                      {langcode === 'en' && (
                        <li>
                          <a
                            href={workAtNchLink}
                            title={workAtNch}
                            className="footer-header-link"
                            rel="noopener noreferrer">
                            <span className="footer-header-link__inside">
                              {workAtNch}
                            </span>
                          </a>
                        </li>
                      )}
                      {langcode === 'sv' && (
                        <li>
                          <a
                            href="https://www.nordicchoicehotels.se/pressrum/#/"
                            title="Pressrum"
                            className="footer-header-link"
                            rel="noopener noreferrer">
                            <span className="footer-header-link__inside">
                              Pressrum
                            </span>
                          </a>
                        </li>
                      )}
                      <li>
                        <a
                          href={becomeAffiliateLink}
                          title={becomeAffiliate}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {becomeAffiliate}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-grid__item footer-grid__item-4">
              <div>
                <div>
                  <div className="footer__box">
                    <div className="h4 footer__title">
                      <div>{ourHotels}</div>
                    </div>
                    <ul className="footer-links ">
                      <li>
                        <a
                          href={comfortHotelLink}
                          title={comfortHotel}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {comfortHotel}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={qualityHotelLink}
                          title={qualityHotel}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {qualityHotel}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={clarionHotelLink}
                          title={clarionHotel}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {clarionHotel}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={independentHotelsLink}
                          title={independentHotels}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {independentHotels}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={airportHotelsLink}
                          title={airportHotels}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {airportHotels}
                          </span>
                        </a>
                      </li>

                      {langcode === 'en' && (
                        <>
                          <li>
                            <a
                              href={spaHotelsLink}
                              title={spaHotels}
                              className="footer-header-link"
                              rel="noopener noreferrer">
                              <span className="footer-header-link__inside">
                                {spaHotels}
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={hotelsWithPoolsLink}
                              title={hotelsWithPools}
                              className="footer-header-link"
                              rel="noopener noreferrer">
                              <span className="footer-header-link__inside">
                                {hotelsWithPools}
                              </span>
                            </a>
                          </li>
                        </>
                      )}
                      <li>
                        <a
                          href={ourDestinationsLink}
                          title={ourDestinations}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {ourDestinations}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-grid__item footer-grid__item-4">
              <div>
                <div>
                  <div className="footer__box">
                    <div className="h4 footer__title">
                      <div>{customerService}</div>
                    </div>
                    <ul className="footer-links">
                      <li>
                        <a
                          href={customerServiceLink}
                          title={customerService}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {customerService}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={contactUsLink}
                          title={contactUs}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {contactUs}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={faqLink}
                          title={faq}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {faq}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={findYourBookingLink}
                          title={findYourBooking}
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {findYourBooking}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={bestPriceGuaranteeLink}
                          title={bestPriceGuarantee}
                          className="footer-header-link   "
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {bestPriceGuarantee}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={userTermsForSiteAndAppLink}
                          title={userTermsForSiteAndApp}
                          className="footer-header-link   "
                          target="_blank"
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {userTermsForSiteAndApp}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={termsAndConditionsPrivacyLink}
                          title={termsAndConditionsPrivacy}
                          className="footer-header-link   "
                          rel="noopener noreferrer">
                          <span className="footer-header-link__inside">
                            {termsAndConditionsPrivacy}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div>
                  <div className="footer__box">
                    <div className="h4 footer__title">
                      <div>{followUs}</div>
                    </div>
                    <ul className="footer-links footer-links--horisontal">
                      <li>
                        <a
                          href="https://www.facebook.com/Nordicchoicehotels"
                          title="Facebook"
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-links__icon  nch-icon-social-facebook" />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://twitter.com/Nordic_Choice"
                          title="Twitter"
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-links__icon  nch-icon-social-twitter" />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/user/nordicchoicehotels"
                          title="YouTube"
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-links__icon  nch-icon-social-youtube" />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.linkedin.com/company/nordic-choice-hotels/"
                          title="Linkedin"
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-links__icon  nch-icon-social-linkedin" />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.pinterest.com/nordicchoice/"
                          title="Pinterest"
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-links__icon  nch-icon-social-pinterest" />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/nordicchoice/"
                          title=" "
                          className="footer-header-link"
                          target="_blank"
                          rel="noopener noreferrer">
                          <span className="footer-links__icon  nch-icon-social-instagram" />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.nordicchoicehotels.com/blog/"
                          title="Blog"
                          className="footer-header-link"
                          rel="noopener noreferrer">
                          <span className="footer-links__icon  nch-icon-icon-blog" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="footer-bottom">
            <div className="footer-bottom__item footer-logo">
              <a
                href="https://www.nordicchoicehotels.se/"
                className="main-page-link">
                <img
                  src="https://www.nordicchoicehotels.com/globalassets/global/footer/nordicchoicehotels-logo.png"
                  alt=""
                  className="footer-logo-img"
                />
              </a>
            </div>
            <div className="footer-bottom__item tripadvisor-logo">
              <a className="en-show" href="http://www.meetingpackage.com/">
                <img
                  width="200px"
                  src="https://meetingpackage.com/sites/all/themes/custom/meetingpackage/images/poweredby/mp_powered_white.png"
                />
              </a>
            </div>
            <div className="footer-bottom__item footer-policy">
              <p>
                © {new Date().getFullYear()} {nch}
              </p>
            </div>
          </section>
        </div>
      </footer>
    </div>
  )
})

export default BookameetingFooter
